import { IOperation } from '../../../../../../util/varibles/interface';
import EtaOperation from '../../../../_components/EtaOperation';
import styles from "./style.module.scss";

const Transport: React.FC<IOperation> = ({ vessel, operation }) => {
    const { source, source_name, destination, destination_name, vessel_name = "" } = operation;
    const { name = vessel_name } = vessel || {};
    const sourceName = source?.name || source_name;
    const destinationName = destination?.name || destination_name;
    return <>
        <div className={styles['line-info']}>
            <div className='flex align-items-center text-truncate'>
                <span className="mr-2">
                    {name}
                </span>
                <EtaOperation data={operation} />
            </div>
        </div>
        <div className={styles['line-info']}>
            <div className='h-24 flex align-items-center text-truncate'>
                {sourceName}
                <span className='arrow-right' />
                {destinationName}
            </div>
        </div>
    </>;
}

export default Transport;
